import { ENDPOINTS } from "@/constants/endpoints"
import { HTTP_METHODS } from "@/constants/httpMethods"
import { QUERY_KEYS } from "@/constants/queryKeys"
import { useGenereicMutation } from "@/hooks/useGenericMutation"
import type { Lecture } from "@/types/lectureTypes"

export function useAttendLectureMutation(roundId?: number) {
  return useGenereicMutation<Lecture>({
    method: HTTP_METHODS.POST,
    invalidationKeys: roundId ? [QUERY_KEYS.enrolledCourses.show(roundId)] : [],
    createEndpoint: (data) =>
      ENDPOINTS.enrolledCourses.attend(
        data.round_id!,
        Number(data.type) === 1 ? "instructor" : "mentor",
        data.id
      ),
  })
}

export function useAddTaskMutation(lecture?: Lecture) {
  return useGenereicMutation<{ task_url: string }>({
    method: HTTP_METHODS.POST,
    invalidationKeys: lecture?.round_id
      ? [QUERY_KEYS.enrolledCourses.show(lecture.round_id)]
      : [],
    createEndpoint: () =>
      ENDPOINTS.enrolledCourses.addTask(
        lecture?.round_id || 0,
        Number(lecture?.type) === 1 ? "instructor" : "mentor",
        lecture?.id || 0
      ),
  })
}
